import { motion } from "framer-motion";
import { useMotion } from "./motion";

let lenisInstance = null;
export const setLenis = (lenis) => {
    lenisInstance = lenis;
};

export const scrollToId = (id) => {
    const el = document.querySelector(id);
    if (!el) return;
    if (lenisInstance) lenisInstance.scrollTo(el, { offset: -64 });
    else el.scrollIntoView({ block: "start" });
};

export const scrollToTop = () => {
    if (lenisInstance) lenisInstance.scrollTo(0);
    else window.scrollTo(0, 0);
};

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => {
    const { reduced } = useMotion();
    if (reduced) {
        return (
            <div className={className} {...rest}>
                {children}
            </div>
        );
    }
    return (
        <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
            className={className}
            {...rest}
        >
            {children}
        </motion.div>
    );
};

export const Eyebrow = ({ children, ...rest }) => (
    <span
        className="inline-flex items-center gap-2 rounded-full border border-cyan-500/20 bg-cyan-950/40 px-3 py-1 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-cyan-400/90 shadow-[0_0_12px_rgba(6,182,212,0.15)] backdrop-blur-sm"
        {...rest}
    >
        {children}
    </span>
);

export const SectionHeading = ({ eyebrow, title, copy, align = "left", testid }) => (
    <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
        <Reveal>
            <Eyebrow data-testid={testid ? `${testid}-eyebrow` : undefined}>{eyebrow}</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="font-display mt-5 text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
                {title}
            </h2>
        </Reveal>
        {copy ? (
            <Reveal delay={0.16}>
                <p className="mt-4 text-sm leading-relaxed text-slate-400 sm:text-base">{copy}</p>
            </Reveal>
        ) : null}
    </div>
);

export const StatusDot = ({ tone = "emerald", className = "" }) => {
    const tones = {
        emerald: "bg-emerald-400 animate-pulse-dot",
        cyan: "bg-cyan-400",
        amber: "bg-amber-400",
        rose: "bg-rose-400",
    };
    return (
        <span className={`inline-block h-1.5 w-1.5 rounded-full ${tones[tone]} ${className}`} />
    );
};
